"use client";
import { createUseSubscriptionHook, RealtimeContextProvider } from "cent-react";
import { RealtimeTypes } from "@zebraex/server/export";
import { api } from "@/trpc/react";
import { env } from "@/env";

const useSubscription = createUseSubscriptionHook<RealtimeTypes.ChannelPrefix, RealtimeTypes.ChannelMessageMap>();

function RealtimeProvider({ children }: { children: React.ReactNode }) {
  const getConnectionToken = api.auth.realtime.getConnectionToken.useMutation();

  return (
    <RealtimeContextProvider debug={true} getToken={getConnectionToken.mutateAsync} endpoint={env.NEXT_PUBLIC_REALTIME_URL} lazy={false}>
      {children}
    </RealtimeContextProvider>
  );
}

export { useSubscription, RealtimeProvider };
